<template>
  <v-container>
    <RequestHeaderForm
        request-id="1234"
        request-status="Submitted for Pricing"
        request-date="2019-05-11"
        approved-date="2019-06-11"
        requestor="JOE KOOL"
        request-type="MDSI Stocking"
        approved-by="SEAGULL"
    />
    <v-data-table
        :headers="headers"
        :items="$store.state.pricingSearchResults"
        class="elevation-1"
    >
      <template v-slot:items="props">
        <template v-if="editingRow !== props.index">
          <td @dblclick="editingRow = props.index">{{ props.item.ItemId }}</td>
          <td class="text-xs-right">{{ props.item.QuantityRequested }}</td>
          <td class="text-xs-right">{{ props.item.QuantityRequestedOriginal }}</td>
          <td class="text-xs-right">{{ props.item.Price }}</td>
          <td class="text-xs-right">{{ props.item.QuantityAwaitingApproval }}</td>
          <td class="text-xs-right">{{ props.item.QuantityApprovedToFulfill }}</td>
          <td class="text-xs-right">{{ props.item.QuantityPassedTesting }}</td>
          <td class="text-xs-right">{{ props.item.QuantityFailedTesting }}</td>
          <td class="text-xs-right">{{ props.item.QuantityRemainingToFulfill }}</td>
        </template>
        <template v-if="editingRow === props.index">
          <td row>
            <v-layout row style="min-width: 200px;">
              <v-btn @click="editingRow = -1" icon color="success"><v-icon>done</v-icon></v-btn>
<!--              <v-text-field v-model="props.item.ItemId" label="Item ID" required ></v-text-field>-->
              <part-number-lookup v-model="props.item.ItemId" />
            </v-layout>
          </td>
          <td ><v-text-field v-model="props.item.QuantityRequested" label="Qty Requested" required ></v-text-field></td>
          <td class="text-xs-right">{{ props.item.QuantityRequestedOriginal }}</td>
          <td ><v-text-field v-model="props.item.Price" label="Price" required style="min-width: 100px;"></v-text-field></td>
          <td class="text-xs-right">{{ props.item.QuantityAwaitingApproval }}</td>
          <td class="text-xs-right">{{ props.item.QuantityApprovedToFulfill }}</td>
          <td class="text-xs-right">{{ props.item.QuantityPassedTesting }}</td>
          <td class="text-xs-right">{{ props.item.QuantityFailedTesting }}</td>
          <td class="text-xs-right">{{ props.item.QuantityRemainingToFulfill }}</td>
        </template>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  import RequestHeaderForm from './RequestHeaderForm';
  import PartNumberLookup from './PartNumberLookup';

  export default {
    name: 'BuybackRequest',
    data() {
      return {
        editingRow: -1,
        headers: [
          { text: 'Requested Item Id', value: 'ItemId', width: '200' },
          { text: 'Qty Requested', value: 'QuantityRequested' },
          { text: 'Qty Requested Orig.', value: 'QuantityRequestedOriginal' },
          { text: 'Price', value: 'Price' },
          { text: 'Qty Awaiting Approval', value: 'QuantityAwaitingApproval' },
          { text: 'Qty Approved to Fulfill', value: 'QuantityApprovedToFulfill' },
          { text: 'Qty Passed Testing', value: 'QuantityPassedTesting' },
          { text: 'Qty Failed Testing', value: 'QuantityFailedTesting' },
          { text: 'Qty Remaining to Fulfill', value: 'QuantityRemainingToFulfill' },
        ],
      };
    },
    components: {
      RequestHeaderForm,
      PartNumberLookup,
    },
    mounted() {

    },
    methods: {

    },
    async beforeCreate() {
      await this.$store.dispatch('SEARCH_PRICING', {});
    },
    beforeUpdate() {
      console.log('beforeUpdate:', this.filter);
      this.$store.commit('SET_BREADCRUMBS', [{ text: 'Pricing Requests', disabled: true }])
    },
  };
</script>

<style>
  .form-field {
    margin: 8px;
  }
</style>
